import React, { Suspense } from 'react'
import { createRootRoute, Outlet, redirect } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/router-devtools'
import Providers from '@/components/Providers'
import ImpersonationBanner from '@/components/ImpersonationBanner'
import BuildVersionWatermark from '@/components/BuildVersionWatermark'
import { TestNav } from '@/components/TestNav'
import { NotFound } from '@/components/errors/NotFound'
import { GlobalLoadingFallback } from '@/components/loading/RouteLoadingFallback'
import { RouteErrorBoundary } from '@/components/errors/RouteErrorBoundary'
import { SkipNavigation } from '@/components/accessibility/SkipNavigation'
import { useKeyboardShortcuts } from '@/components/accessibility/KeyboardShortcutsModal'
import {
  extractSubdomainFromHostname,
  validateSubdomain,
  getEffectiveTenantDomain,
  type TenantRouterContext,
} from '@/lib/router/tenant-detection'

export const Route = createRootRoute({
  beforeLoad: async (): Promise<TenantRouterContext> => {
    // Extract subdomain from hostname
    const hostname = window.location.hostname
    const subdomain = extractSubdomainFromHostname(hostname)

    // Validate subdomain
    // const validation = validateSubdomain(subdomain)
    // if (!validation.isValid) {
    //   // For reserved/invalid subdomains, redirect to error page
    //   throw redirect({
    //     to: '/error',
    //     search: {
    //       reason: 'invalid-subdomain',
    //       subdomain,
    //       message: validation.error || 'Invalid subdomain',
    //     },
    //   })
    // }

    // Get effective tenant domain for API calls
    const tenantDomain = getEffectiveTenantDomain(hostname)

    // Return tenant context for child routes
    return {
      subdomain,
      tenantDomain,
    }
  },
  component: RootComponent,
  notFoundComponent: NotFound,
})

function RootComponent() {
  const { KeyboardShortcutsModal } = useKeyboardShortcuts()

  return (
    <RouteErrorBoundary>
      <Providers>
        <SkipNavigation />
        <ImpersonationBanner />
        {/* {import.meta.env.DEV && <TestNav />} */}
        <Suspense fallback={<GlobalLoadingFallback />}>
          <Outlet />
        </Suspense>
        {/* <BuildVersionWatermark /> */}
        {KeyboardShortcutsModal}
        {/* {import.meta.env.DEV && <TanStackRouterDevtools />} */}
      </Providers>
    </RouteErrorBoundary>
  )
}
